module.exports = __webpack_public_path__ + "static/media/water9_1608741518220.df642079.png";